export default {"src":"/_next/static/media/twitter-sign.f5670aca.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};